import LeftRobotCard from './common/LeftRobotCard'
import Button from 'components/forms/Button'
import useWindowSize from 'components/util/useWindowSize'
import useShoppingBag from 'common/useShoppingBag'
import { useRouter } from 'next/router'
import { planPrice } from 'common/utils/planPrice'
import { AddonSlug, PlanSlug } from 'common/planSlugs'
import { FC } from 'react'
import { TAddon, TPlanSummary } from 'common/cms-types'
import { Format } from 'common/utils'

type VirtualAddressPromoCardType = {
  addons: TAddon[]
  planSummary: TPlanSummary
}

const VirtualAddressPromoCard: FC<VirtualAddressPromoCardType> = ({
  addons,
  planSummary,
}) => {
  const size = useWindowSize()
  const { addPlan } = useShoppingBag()
  const router = useRouter()
  const onBuyClick = () => {
    addPlan(planSummary.slug, 'year', planSummary)
    router.push('/checkout')
  }
  return (
    <LeftRobotCard
      image={{
        alt: 'Robot arm with mail',
        desktop: {
          dimensions: {
            height: 635,
            width: 467,
          },
          src: '/images/new/robot-arm-cut.png',
        },
        mobile: {
          dimensions: {
            height: 704,
            width: 550,
          },
          src: '/images/new/robot-arm-mail.png',
        },
      }}
      imageContainerWidth={size.isLgOrHigher ? '35%' : '100%'}
      imageStyle={{
        maxWidth: '100%',
        objectFit: 'cover',
        objectPosition: 'right',
      }}
    >
      <div className='d-flex flex-1 flex-column gap-4 px-4 pt-4 pb-5 pe-lg-8 pt-lg-17 pb-lg-7 mt-lg-0 mt-n17'>
        <h2 className='fw-semibold lh-105 fs-fluid-36-52'>
          Set up your company's virtual address in{' '}
          <span className='color-pink2'>less than 10 minutes</span>.
        </h2>
        <span className=' fw-semibold lh-119 fs-18'>
          <h3 className='fw-semibold fs-fluid-18-28'>
            Get a prestigious business address and unlock AI-powered mail
            handling from as little as{' '}
            {planPrice.monthlyOnYearlyPlan(PlanSlug.SCAN_LITE)}
            /month.
            <br />
            Use the address at Companies House to keep your residential address
            private.
          </h3>
          <br />
          <br />
          <span className='lh-132'>
            We receive,{' '}
            <span>
              <span className='fw-bold'>
                securely process, and digitise your mail with HaiRo™
              </span>
              , sending it to you within 1 business day. Using the registered
              office address at Companies House helps keep your personal address
              private.
            </span>
            <br />
            <br />
            <span className='fw-bold'>Physical mail is stored for 30 </span>
            days before secure shredding.
            <br />
            <br />
            <span className='fw-bold'>Need a copy?</span> We forward mail
            anywhere in the UK for the cost of a 1st class stamp + 50p.
            <br />
            <br />
            Add a{' '}
            <span className='fw-bold'>
              London virtual landline number
            </span> for{' '}
            {Format.money(
              (addons.find((v) => v.slug === AddonSlug.VIRTUAL_OFFICE_PHONE)
                ?.pricing.year_price ?? 0) / 12,
            )}
            /month.
          </span>
          <br />
          {/*Always fs 16*/}
          <span className='fs-16 color-grey5'>
            Only available as an add on, virtual office subscription required.
          </span>
        </span>
        <Button onClick={onBuyClick} className='align-self-lg-end px-22'>
          Buy Now
        </Button>
      </div>
    </LeftRobotCard>
  )
}

export default VirtualAddressPromoCard
